<template>
    <div>
        <v-select :multiple="false" :options="optionsTiendas" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedTiendas" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "tiendasSimple",
    props: {
        placeholderm: String,
        tienda: {
            type: Boolean,
            default: true,
            required: false
        },
    },
    data(){
        return{
            selectedTiendas:null,
            optionsTiendas:[],
            formatos:[]
        }
    },
    mounted() {
        this.getTiendas();
    },
    methods:{
        getTiendas(){ let $this = this;
            console.log(this.tienda);
            axios
                .post('/api/AdminCatalogos/tiendasSelectD', {
                    formatos: this.formatos,
                    tienda: this.tienda
                })
                .then(function (r){
                    $this.optionsTiendas = r.data.slice(1);
                });
        },
        setCambio(){
            this.$emit('cambioTienda');
        }
    }
}
</script>

<style scoped>

</style>
